import { useSelector } from 'react-redux';

import { CurrentUser } from 'types/CurrentUser';
import { selectCurrentUser } from 'containers/App/selectors';

export const useCurrentUser = (): CurrentUser | undefined =>
  useSelector(selectCurrentUser);
